export const environment: any = {
	production: false,
	ENV: 'HOMOLOG',
	PATH: 'https://homolog.arbolink.com.br/api',
	GOOGLE_API_KEY: 'AIzaSyCfLiTKRUCjB4U823089ODXS9q94u5yquc'
}
